// src/layers/imagery/effectiveDate.js
//
// Snap a cursor date to the latest acquisition on-or-before it — the same
// on-or-before walk the resolver uses. A pinned entry resolves against its
// pinned_date; otherwise against the global cursor date. Returns the
// acquisition_date string, or null when there's nothing on-or-before.

// ── THERE ARE THREE time_mode VALUES AND HALF THE CODE KNOWS ABOUT TWO ─────
//
// The store writes "global" (addLayer's default, `:191`, and `:385`) but
// setTimeMode accepts ONLY "pinned" or "follow_cursor" and rejects "global"
// outright. So a layer that has never been toggled sits at "global", which is
// not a value setTimeMode can produce and not one the readers recognise:
// FollowModeHUD, TimeSlider and ActiveLayers all test `=== "follow_cursor"`,
// and all three therefore report a freshly-added layer as NOT following the
// cursor when it is.
//
// The rendering has always been right, which is why this survived: the resolver
// below and resolveImageryStack both ask `=== "pinned"` and treat everything
// else as cursor-following, so "global" and "follow_cursor" are already the
// same thing to the code that decides which imagery to draw. Only the
// indicators disagreed.
//
// This is the predicate, stated once. It is deliberately "not pinned" rather
// than a list of following-modes, because that is the actual rule and a list
// would need editing the next time a mode is added — which is exactly how the
// three call sites drifted.
export function isFollowingCursor(entry) {
  return !!entry && entry.time_mode !== "pinned";
}

export function effectiveDateFor(series, entry, cursorDate) {
  const cursor = entry.time_mode === "pinned" ? entry.pinned_date : cursorDate;
  const acquisitions = series?.acquisitions ?? [];
  if (!cursor || !acquisitions.length) return null;
  for (let i = acquisitions.length - 1; i >= 0; i--) {
    if (acquisitions[i].acquisition_date <= cursor) {
      return acquisitions[i].acquisition_date;
    }
  }
  return null;
}
